<app-header></app-header>

<section class="bredcrumb bg-grey">
  <div class="container">
    <ul class="brd-nav">
      <li> <a> Notifications </a></li>
    </ul>
    <div class="add-treatment" *ngIf="!!allNotificaitons?.length">
      <a (click)="confirmClick()" style="cursor: pointer;color: #42abe4;"> Clear Notifications </a>
    </div>
  </div>
</section>

<section class="single-page doc-dashboard-body padd-row bg-grey">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 mb-3" *ngFor="let data of allNotificaitons">
        <div class="doc-dashborad-right-sidebar padd-bdr-white-bg">
          <div class="total-patients-doc-dashobard mb-0">
            <h4 class="mb-2">
              {{data?.title}}
              <span style="float: right;">{{data?.timeStamp | date: 'medium'}}</span>
            </h4>
            <div>
              {{data?.message}}
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 mt-5 mb-5 text-center" *ngIf="!allNotificaitons?.length">
        <div class="doc-dashborad-right-sidebar padd-bdr-white-bg">
          <div class="total-patients-doc-dashobard mb-0 pt-5 pb-5">
            <h3>No Notification!</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<input type="hidden" data-toggle="modal" id="delete_confirm" data-target="#delete_confirm_notification">

<!-- The Modal -->
<div class="modal fade" id="delete_confirm_notification">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal body -->
      <div class="modal-body">
        <div class="sign-up-form order-confirmed">
          <h2 class="text-center"> <span> Clear Notification Confirmation </span> </h2>
          <h5> Are you sure, you want to clear all Notifications </h5>
          <!-- <h5> You Can review your order </h5> -->
          <a (click)="confirmClick()" class="btn-style mr-3"> Cancel </a>
          <a (click)="clearNotification()" class="btn-style"> Ok </a>
        </div>
      </div>
    </div>
  </div>
</div>